<template>
  <div class="border rounded-lg p-6">
    <div class="font-semibold text-black text-xl mb-6">
      Gudang Mitra Kompack
    </div>
    <div
      v-if="isLoading && !isRetry"
      class="grid grid-cols-1 lg:grid-cols-2 gap-6"
    >
      <div
        v-for="i in 2"
        :key="i"
        class="border rounded-lg h-[335px] bg-[#f4f4f4] animate-pulse"
      />
    </div>
    <div
      v-else-if="isError"
      class="flex flex-col gap-[8px] justify-center items-center h-[335px]"
    >
      <div class="flex items-center gap-[8px]">
        <span class="k-info-circle text-[20px] text-[#828282]" />
        Terjadi kesalahan saat mengambil data gudang mitra kompack
      </div>
      <b-button
        variant="primary"
        size="sm"
        class="!flex items-center gap-[8px]"
        :disabled="isRetry"
        @click="retryFetchSubscribedWarehouses"
      >
        <b-spinner
          v-if="isRetry"
          small
          variant="light"
        />
        {{ isRetry ? 'Mencoba...' : 'Coba Lagi' }}
      </b-button>
    </div>
    <div
      v-else
      class="grid grid-cols-1 lg:grid-cols-2 gap-6"
    >
      <div
        v-for="(item, i) in subscribedWarehouses"
        :key="i"
      >
        <div class="border rounded-lg">
          <WarehouseCardHeader :item="item" />
          <WarehouseCardOderInfo
            :show-by-default="i <= 1"
            :warehouse="item"
          />
          <WarehouseCardProduct :item="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WarehouseCardHeader from './components/WarehouseCardHeader.vue'
import WarehouseCardOderInfo from './components/WarehouseCardOderInfo.vue'
import WarehouseCardProduct from './components/WarehouseCardProduct.vue'

export default {
  components: {
    WarehouseCardHeader,
    WarehouseCardOderInfo,
    WarehouseCardProduct,
  },
  data() {
    return {
      subscribedWarehouses: undefined,
      isLoading: false,
      isError: false,
      isRetry: false,
    }
  },
  mounted() {
    this.fetchSubscribedWarehouses()
  },
  methods: {
    /**
     * Fetch the subscribed warehouses from the server.
     */
    async fetchSubscribedWarehouses() {
      this.isLoading = true
      try {
        const res = await this.$http_new.get('komship/api/v1/subscribe-warehouses/partner')
        const { data } = res.data
        this.subscribedWarehouses = data
        this.isError = false
      } catch {
        this.isError = true
      } finally {
        this.isLoading = false
      }
    },
    /**
     * Retry the fetch of the subscribed warehouses if error occurs.
     */
    async retryFetchSubscribedWarehouses() {
      this.isRetry = true
      await this.fetchSubscribedWarehouses()
      this.isRetry = false
    },
  },
}
</script>

<style>
.flatpickr-monthSelect-month.selected{
  background-color: #F95031 !important;
}
.flatpickr-monthSelect-month{
    font-weight: 600 !important;
}
.flatpickr-current-month input.cur-year{
    font-weight: 600 !important;
}
</style>
